module.exports = __webpack_public_path__ + "img/filter.3c867e02.svg";